<template>
  <b-card title="مدیریت بانک‌ها">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="openAdd()"
              >
                جدید
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openEdit(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Title)="data">
            <span class="text-nowrap">
              <b-avatar
                class="mr-50"
                :src="data.item.Logo"
                rounded
              >
                <feather-icon
                  v-if="!data.item.Logo"
                  icon="ImageIcon"
                />
              </b-avatar>
              {{ data.value }}
            </span>
          </template>

          <template #cell(IsActive)="data">
            <b-badge :variant="data.value ? 'success' : 'warning'">
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-link @click="openEdit(data.item)">
                <feather-icon
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer text-danger"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal
      v-if="showModal"
      v-model="showModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      :title="row.Id ? 'ویرایش بانک' : 'افزودن بانک'"
      :no-close-on-backdrop="true"
      size="md"
      @ok.prevent="save"
    >
      <b-row>
        <b-col
          md="3"
          class="text-center mb-2"
        >
          <input
            ref="refLogo"
            type="file"
            class="d-none"
            accept="image/*"
            @change="logoRenderer($event)"
          >
          <label style="font-weight: 600; display: block">لوگو</label>
          <div
            class="order-upload mx-auto"
            @click="$refs.refLogo.click()"
          >
            <img
              v-if="row.Logo"
              :src="row.Logo"
            >
            <div v-else>
              <feather-icon
                size="24"
                icon="UploadIcon"
              />
            </div>
          </div>
        </b-col>

        <b-col md="9">
          <b-form-group
            label="عنوان"
            label-for="Title"
          >
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
            />
          </b-form-group>

          <b-form-group
            label="وضعیت"
            label-for="IsActive"
          >
            <v-select
              v-model="row.IsActive"
              :options="activeOptions"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'Bank',
  data() {
    return {
      loading: false,
      items: [],
      showModal: false,
      row: {},
      activeOptions: [
        { text: 'فعال', value: true },
        { text: 'غیرفعال', value: false },
      ],
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Title', label: 'عنوان' },
        { key: 'IsActive', label: 'وضعیت' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
    }
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.loading = true
      this.$http.post(this.$api.bank.getlist, {})
        .then(res => {
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAdd() {
      this.row = { Title: null, IsActive: true, Logo: null }
      this.showModal = true
    },
    openEdit(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.showModal = true
    },
    save() {
      const url = this.row.Id ? this.$api.bank.update : this.$api.bank.add

      const formData = new FormData()
      if (this.row.Id) formData.append('Id', this.row.Id)
      formData.append('Title', this.row.Title || '')
      formData.append('IsActive', this.row.IsActive)

      const logo = this.$refs.refLogo.files[0]
      if (logo) formData.append('Logo', logo)

      this.$http.post(url, formData)
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.bank.remove, 'Id', id)
    },
    logoRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])
      fileReader.onload = () => {
        this.$set(this.row, 'Logo', fileReader.result)
      }
    },
  },
}
</script>

<style scoped>
.order-upload {
  align-items: center;
  display: flex;
  height: 90px;
  justify-content: center;
  width: 90px;
  text-align: center;
  border: 1px solid #dbdade;
  cursor: pointer;
  border-radius: 0.357rem;
  flex-direction: column;
}

.order-upload img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 0.357rem;
}
</style>
